module.exports = __webpack_public_path__ + "img/logo-blanco-innofarm.ed4bd1c8.png";